export const VideoExtensions = ['.mpg', '.mp4', '.ogv', '.mov', '.webm'];
export const AudioExtensions = ['.aac', '.mp3', '.oga', '.ogg', '.wav'];
export const ImageExtensions = [
    '.apng',
    '.bmp',
    '.gif',
    '.ico',
    '.cur',
    '.jpg',
    '.jpeg',
    '.jfif',
    '.pjpeg',
    '.pjp',
    '.png',
    '.svg',
    '.tif',
    '.tiff',
    '.webp',
];

export const TextExtensions = [
    '.js',
    '.css',
    '.html',
    '.svg',
    '.txt',
    '.htm',
    '.scss',
    '.csv',
    '.less',
];

export const FontExtensions = ['.ttf', '.otf', '.woff', '.woff2'];

export const FileTypeExtensions = {
    IMAGE: ImageExtensions,
    VIDEO: VideoExtensions,
    AUDIO: AudioExtensions,
    FONT: FontExtensions,
    TEXT: TextExtensions,
};
